import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ContactSystem from '../../ContactME/ContactSystem';

const Contact = () => {
    return (
        <Container className='py-5'>
            <Row className='pt-5'>
                <Col md={7} className="d-flex align-items-center" >
                    <div align="center" className="contact-section p-3 mt-5 ">
                        <div>
                            <h5>What's Next ?</h5>
                            <h1>Get In Touch</h1>
                            <p >I'd Love to hear from you . Whether you have a question or just want to say hi, fell free to drop a message. I'll try my best to get back to you!</p>
                            <Link to="/contactme"><Button className="buttonstyle">Say Hello</Button></Link>
                        </div>
                    </div>
                </Col>
                <Col md={5}>
                    <ContactSystem />
                </Col>
            </Row>
        </Container>
    );
};

export default Contact;